import p1 from '@/assets/img/p-1.jpg'
import p2 from '@/assets/img/p-2.jpg'
import p3 from '@/assets/img/p-3.jpg'
import p4 from '@/assets/img/p-4.jpg'
import p5 from '@/assets/img/p-5.jpg'
import p6 from '@/assets/img/p-6.jpg'
import p7 from '@/assets/img/p-7.jpg'
import p8 from '@/assets/img/p-8.jpg'
import p9 from '@/assets/img/p-9.jpg'
import p10 from '@/assets/img/p-10.jpg'
import p11 from '@/assets/img/p-11.jpg'
import p12 from '@/assets/img/p-12.jpg'
import p13 from '@/assets/img/p-13.jpg'
import p14 from '@/assets/img/p-14.jpg'
// import p15 from '@/assets/img/p-15.jpg'
// import p16 from '@/assets/img/p-16.jpg'
import p17 from '@/assets/img/p-17.jpg'
import p18 from '@/assets/img/p-18.jpg'
import p19 from '@/assets/img/p-19.jpg'
import p20 from '@/assets/img/p-20.jpg'
import p21 from '@/assets/img/p-21.jpg'
import p22 from '@/assets/img/p-22.jpg'

import work1 from '@/assets/img/svg/work-1.svg'
import work2 from '@/assets/img/svg/work-2.svg'
import work3 from '@/assets/img/svg/work-3.svg'

import c1 from '@/assets/img/c-1.png'
import c2 from '@/assets/img/c-2.png'
import c3 from '@/assets/img/c-3.png'
import c4 from '@/assets/img/c-4.png'
import c5 from '@/assets/img/c-5.png'
import c6 from '@/assets/img/c-6.png'
import c7 from '@/assets/img/c-7.png'
import c8 from '@/assets/img/c-8.png'

import ct1 from '@/assets/img/ct-1.png'
import ct2 from '@/assets/img/ct-2.png'
import ct3 from '@/assets/img/ct-3.png'
import ct4 from '@/assets/img/ct-4.png'
import ct5 from '@/assets/img/ct-5.png'
import ct6 from '@/assets/img/ct-6.png'
import ct7 from '@/assets/img/ct-7.png'
import ct8 from '@/assets/img/ct-8.png'
import ct9 from '@/assets/img/ct-9.png'
import ct10 from '@/assets/img/ct-10.png'
import ct11 from '@/assets/img/ct-11.png'
import ct12 from '@/assets/img/ct-12.png'
import ct13 from '@/assets/img/ct-13.png'

import client1 from '@/assets/img/user-1.jpg'
import client2 from '@/assets/img/user-2.jpg'
import client3 from '@/assets/img/user-3.jpg'
import client4 from '@/assets/img/user-4.jpg'
import client5 from '@/assets/img/user-5.jpg'
import client6 from '@/assets/img/user-6.jpg'
import client7 from '@/assets/img/user-7.jpg'
import client8 from '@/assets/img/user-8.jpg'

import pl1 from '@/assets/img/partners/booking.png'
import pl2 from '@/assets/img/partners/columbia.png'
import pl3 from '@/assets/img/partners/Payoneer.png'
import pl4 from '@/assets/img/partners/Paypal.png'
import pl5 from '@/assets/img/partners/razorpay.png'
import pl6 from '@/assets/img/partners/microsoft.png'
import pl7 from '@/assets/img/partners/trivago.png'
import pl8 from '@/assets/img/partners/visa.png'
import pl9 from '@/assets/img/partners/columbia.png'

import pr1 from '@/assets/img/partners/booking-light.png'
import pr2 from '@/assets/img/partners/columbia-light.png'
import pr3 from '@/assets/img/partners/Payoneer-light.png'
import pr4 from '@/assets/img/partners/Paypal-light.png'
import pr5 from '@/assets/img/partners/razorpay-light.png'
import pr6 from '@/assets/img/partners/microsoft-light.png'
import pr7 from '@/assets/img/partners/trivago-light.png'
import pr8 from '@/assets/img/partners/visa-light.png'
import pr9 from '@/assets/img/partners/columbia-light.png'

import ag1 from '@/assets/img/ag-1.png'
import ag2 from '@/assets/img/ag-2.png'
import ag3 from '@/assets/img/ag-3.png'
import ag4 from '@/assets/img/ag-4.png'
import ag5 from '@/assets/img/ag-5.png'
import ag6 from '@/assets/img/ag-6.png'
import ag7 from '@/assets/img/ag-7.png'
import ag8 from '@/assets/img/ag-8.png'

import team1 from '@/assets/img/team-1.jpg'
import team2 from '@/assets/img/team-2.jpg'
import team3 from '@/assets/img/team-3.jpg'
import team4 from '@/assets/img/team-4.jpg'
import team5 from '@/assets/img/team-5.jpg'
import team6 from '@/assets/img/team-6.jpg'

import tour1 from '@/assets/img/tour-1.jpg'
import tour2 from '@/assets/img/tour-2.jpg'
import tour3 from '@/assets/img/tour-3.jpg'
import tour4 from '@/assets/img/tour-4.jpg'
import tour5 from '@/assets/img/tour-5.jpg'



export const navProperty = [
    {
        image:p1,
        name:'Loss vengel New Apartment',
        loction:'Sans Fransico',
        type:"For Sale",
        value:'$4,240'
    },
    {
        image:p2,
        name:'Montreal Quriqe Apartment',
        loction:'Liverpool, London',
        type:"For Rent",
        value:'$7,380'
    },
    {
        image:p3,
        name:'Curmic Studio For Office',
        loction:'Montreal, Canada',
        type:"For Buy",
        value:'$8,730'
    },
    {
        image:p4,
        name:'Sreek View, New York',
        loction:'Sans Fransico',
        type:"For Rent",
        value:'$6,240'
    },
]
export const navProperty2 = [
    {
        image:p5,
        name:'Loss vengel New Apartment',
        loction:'Sans Fransico',
        type:"For Sale",
        value:'$4,240'
    },
    {
        image:p6,
        name:'Montreal Quriqe Apartment',
        loction:'Liverpool, London',
        type:"For Rent",
        value:'$7,380'
    },
    {
        image:p7,
        name:'Curmic Studio For Office',
        loction:'Montreal, Canada',
        type:"For Buy",
        value:'$8,730'
    },
    {
        image:p8,
        name:'Sreek View, New York',
        loction:'Sans Fransico',
        type:"For Rent",
        value:'$6,240'
    },
]

export const workDataEn = [
    {
        id:1,
        image:work1,
        title:'Search',
        desc:'Search for the professionals you need within a specific area and governorate using the search field.',
        bg:'f-light-success'
    },
    {
        id:2,
        image:work2,
        title:'Contact',
        desc:'Contact the professional through the information available on the platform.',
        bg:'f-light-warning'
    },
    {
        id:3,
        image:work3,
        title:'Get',
        desc:'Get the service easily and smoothly directly from the provider without intermediaries or effort.',
        bg:'f-light-purple'
    },
]
export const workData = [
    {
        id:1,
        image:work1,
        title:'ابحث',
        desc:'ابحث عن أصحاب المهن التي تريدها ضمن منطقة ومحافظة معينة من حقل البحث',
        bg:'f-light-success'
    },
    {
        id:2,
        image:work2,
        title:'تواصل',
        desc:'تواصل مع صاحب المهنة من خلال معلوماته المتواجدة في المنصة',
        bg:'f-light-warning'
    },
    {
        id:3,
        image:work3,
        title:'احصل',
        desc:'احصل على الخدمة بكل سهولة ويسر مباشرة من مقدمها دون وساطات أو جهد',
        bg:'f-light-purple'
    },
]
export const workDataTr = [
  {
    id: 1,
    image: work1,
    title: 'Ara',
    desc: 'Arama alanından istediğiniz meslek sahiplerini belirli bir bölge ve ilde arayın',
    bg: 'f-light-success'
  },
  {
    id: 2,
    image: work2,
    title: 'İletişim',
    desc: 'Platformda bulunan bilgileri kullanarak meslek sahibi ile iletişime geçin',
    bg: 'f-light-warning'
  },
  {
    id: 3,
    image: work3,
    title: 'Hizmet Al',
    desc: 'Hizmeti kolayca ve doğrudan sağlayıcıdan, aracı olmadan alın',
    bg: 'f-light-purple'
  },
];

export const propertyData = [
    {
        id:1,
        image:[p1,p9,p10],
        tag:['Verified'],
        tag2:'For Rent',
        type:'Apartment',
        name:'The Green Canton Chrysler',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$80,000'
    },
    {
        id:2,
        image:[p2,p6,p8],
        tag:['SuperAgent'],
        tag2:'For Sell',
        type:'House',
        name:'Purple Flatiron House',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$67,000'
    },
    {
        id:3,
        image:[p3,p5,p7],
        tag:['Verified','New'],
        tag2:'For Rent',
        type:'Building',
        name:'The Green Canton Chrysler',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$92,500'
    },
    {
        id:4,
        image:[p4,p6,p9],
        tag:['SuperAgent'],
        tag2:'For Sell',
        type:'Condos',
        name:'The Red Freedom Tower',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$89,000'
    },
    {
        id:5,
        image:[p5,p12,p13],
        tag:['Verified','New'],
        tag2:'For Rent',
        type:'Villa',
        name:'The Donald Dwelling',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$88,000'
    },
    {
        id:6,
        image:[p6,p7,p11],
        tag:['SuperAgent'],
        tag2:'For Sell',
        type:'Building',
        name:'Red Tiny Hearst Castle',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$10,50000'
    },
    {
        id:7,
        image:[p22,p3,p5],
        tag:['SuperAgent'],
        tag2:'For Sell',
        type:'Condos',
        name:'The Red Freedom Tower',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$89,000'
    },
    {
        id:8,
        image:[p12,p13,p14],
        tag:['Verified','New'],
        tag2:'For Rent',
        type:'Villa',
        name:'The Donald Dwelling',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$88,000'
    },
    {
        id:9,
        image:[p7,p8,p12],
        tag:['SuperAgent'],
        tag2:'For Sell',
        type:'Building',
        name:'Red Tiny Hearst Castle',
        loction:'210 Zirak Road, Canada',
        size:'3BHK',
        beds:'3 Beds',
        sqft:'1800 SQFT',
        value:'$10,50000'
    },
]

export const bestLoction = [
    {
        image:c1,
        location:'San Francisco, California',
        properties:'95 Properties'
    },
    {
        image:c2,
        location:'Dunao, California',
        properties:'95 Properties'
    },
    {
        image:c3,
        location:'Liverpool, London',
        properties:'95 Properties'
    },
    {
        image:c4,
        location:'San Francisco, New York',
        properties:'95 Properties'
    },
    {
        image:c5,
        location:'New Orleans, Louisiana',
        properties:'95 Properties'
    },
    {
        image:c6,
        location:'Los Angeles',
        properties:'95 Properties'
    },
    {
        image:c7,
        location:'Dubai, UAE',
        properties:'95 Properties'
    },
    {
        image:c8,
        location:'Dhaka, UAE',
        properties:'95 Properties'
    },
]

export const clientDataEn = [
    {
        image:client1,
        quote:'bg-primary',
        desc:'I urgently needed a carpenter, and within minutes of searching, I was able to agree with a carpenter and set an appointment through the platform. The service was fast and very convenient.',
        name:'Ahmed Al-Zahrani',
        // position:'CEO Of Microwoft'
    },
    {
        image:client2,
        quote:'bg-success',
        desc:'The platform saved me a lot of time and effort searching for an air conditioning technician for my home. By following the reviews, I was able to get a high-quality, reliable service in an easy and comfortable way.',
        name:'Rahaf Al-Anabi',
        // position:'CEO Of Apple'
    },
    {
        image:client3,
        quote:'bg-purple',
        desc:'I am an electrician, and I have always been looking for a way to reach a larger group of customers. The platform has provided me with access to many customers, and I now receive many requests continuously.',
        name:'Saeed Al-Omari',
        // position:'Pio Founder'
    },
    {
        image:client4,
        quote:'bg-seegreen',
        desc:'I work as a technician specializing in the maintenance of all types of refrigerators. The platform has helped me reach many customers and expand the range of my services within the governorate in an easy, smooth, and organized way.',
        name:'Mohammed Al-Shaher',
        // position:'CEO Of Facewarm'
    },
    {
        image:client5,
        quote:'bg-danger',
        desc:'During a simple search, I found a painter with high expertise and excellent work quality. The platform truly saves a lot of time and effort and connects us to what we seek with great ease.',
        name:'Samira Al-Masoudi',
        // position:'CEO Of Zapple'
    },
]
export const clientData = [
    {
        image:client1,
        quote:'bg-primary',
        desc:'كنت بحاجة إلى نجار بشكل عاجل، وخلال دقائق من البحث استطعت الاتفاق مع نجار وتثبيت موعد عن طريق المنصة، والخدمة كانت سريعة ومناسبة جداً.',
        name:'أحمد الزهراني',
        // position:'CEO Of Microwoft'
    },
    {
        image:client2,
        quote:'bg-success',
        desc:'وفرت المنصة علي الكثير من الوقت والجهد في البحث عن فني لصيانة التكييف في منزلي، ومن خلال متابعة التقييمات استطعت الحصول على خدمة بجودة عالية وموثوقة وبطريقة سهلة ومريحة.',
        name:'رهف العنابي',
        // position:'CEO Of Apple'
    },
    {
        image:client3,
        quote:'bg-purple',
        desc:'أنا كهربائي، ودائماً كنت أبحث عن طريقة للوصول إلى شريحة أكبر من العملاء، وقد وفرت لي المنصة وصولاً إلى الكثير من العملاء وبت أستقبل الكثير من الطلبات بشكل مستمر.',
        name:'سعيد العمري',
        // position:'Pio Founder'
    },
    {
        image:client4,
        quote:'bg-seegreen',
        desc:'أعمل فنياً في صيانة الثلاجات بأنواعها، وقد ساعدتني المنصة على الوصول إلى الكثير من العملاء وتوسيع رقعة خدماتي ضمن المحافظة بشكل سهل وسلس ومنظم.',
        name:'محمد الشاهر',
        // position:'CEO Of Facewarm'
    },
    {
        image:client5,
        quote:'bg-danger',
        desc:'خلال عملية بحث بسيطة وصلت إلى دهّان بخبرة عالية وجودة عمل رائعة، فالمنصة فعلاً توفر الكثير من الوقت والجهد وتوصلنا إلى مبتغانا بكل سهولة.',
        name:'سميرة المسعودي',
        // position:'CEO Of Zapple'
    },
]
export const clientDataTr = [
  {
    image: client1,
    quote: 'bg-primary',
    desc: 'Acil olarak bir marangoz ihtiyacım vardı. Platformda birkaç dakika arama yaptıktan sonra bir marangozla anlaşabildim ve randevu ayarladım. Hizmet çok hızlı ve uygundu.',
    name: 'Ahmed Zehrani',
    // position: 'CEO Of Microwoft'
  },
  {
    image: client2,
    quote: 'bg-success',
    desc: 'Platform bana evimde klima bakım ustası ararken çok zaman ve çaba kazandırdı. Değerlendirmeleri takip ederek yüksek kaliteli ve güvenilir bir hizmet alabildim. Süreç çok kolay ve rahattı.',
    name: 'Rahaf Alenabi',
    // position: 'CEO Of Apple'
  },
  {
    image: client3,
    quote: 'bg-purple',
    desc: 'Ben bir elektrikçiyim ve her zaman daha fazla müşteriye ulaşmanın bir yolunu arıyordum. Platform bana çok sayıda müşteriye erişim sağladı ve artık sürekli yeni talepler alıyorum.',
    name: 'Said Alomari',
    // position: 'Pio Founder'
  },
  {
    image: client4,
    quote: 'bg-seegreen',
    desc: 'Buzdolabı tamircisi olarak çalışıyorum. Platform bana birçok müşteriye ulaşma ve hizmetlerimi il genelinde kolay, düzenli ve verimli bir şekilde genişletme imkânı sağladı.',
    name: 'Muhammed Alşahir',
    // position: 'CEO Of Facewarm'
  },
  {
    image: client5,
    quote: 'bg-danger',
    desc: 'Basit bir arama yaparak yüksek deneyime sahip harika bir boyacı buldum. Platform gerçekten çok zaman ve emek tasarrufu sağlıyor ve bizi kolayca istediğimiz hizmete ulaştırıyor.',
    name: 'Samira Almasoudi',
    // position: 'CEO Of Zapple'
  },
];

export const pricingData = [
    {
        value:49,
        title:'Basic Package',
        feature:['5+ Listings','Contact With Agent','3 Month Validity','7x24 Fully Support','50GB Space'],
        btn:'btn btn-light-primary rounded full-width',
        bg:'bg-dark',
        titleText:'text-info'
    },
    {
        value:99,
        title:'PLATINUM PACKAGE',
        feature:['5+ Listings','Contact With Agent','3 Month Validity','7x24 Fully Support','50GB Space'],
        btn:'btn btn-dark rounded full-width',
        bg:'bg-primary',
        titleText:'text-light'
    },
    {
        value:199,
        title:'STANDARD PACKAGE',
        feature:['5+ Listings','Contact With Agent','3 Month Validity','7x24 Fully Support','50GB Space'],
        btn:'btn btn-light-primary rounded full-width',
        bg:'bg-dark',
        titleText:'text-info'
    },
]

export const footerLink1 = [
    {
        title:'About Us',
        link:'/about-us'
    },
    {
        title:'FAQs Page',
        link:'/faq'
    },
    {
        title:'Checkout',
        link:'/checkout'
    },
    {
        title:'Contact',
        link:'/contact'
    },
    {
        title:'Blog',
        link:'/blog'
    },
]

export const footerLink2 = [
        'Apartment','My Houses','Restaurant','Nightlife','Villas'
]
export const footerLink3 = [
        'My Profile','My account','My Property','Favorites','Cart'
]
export const achievementDataTr = [
  {
    title: 'Hizmet Sağlayıcıları',
    value: 500,
    symbol: '+'
  },
  {
    title: 'Kullanıcı Sayısı',
    value: 2000,
    symbol: '+'
  },
  {
    title: 'Hizmet Verilen İller',
    value: 7,
    symbol: '+'
  },
  {
    title: 'Faydalanan Bölgeler',
    value: 400,
    symbol: '+'
  },
];

export const achievementData = [
    {
        title:'مزودي الخدمة',
        value:500,
        symbol:'+'
    },
    {
        title:'عدد المستخدمين',
        value:2000,
        symbol:'+'
    },
    {
        title:'محافظة مغطاة بالخدمات',
        value:7,
        symbol:'+'
    },
    {
        title:'منطقة مستفيدة ',
        value:400,
        symbol:'+'
    },
]
export const achievementDataEn = [
    {
        title:'Service Providers.',
        value:500,
        symbol:'+'
    },
    {
        title:'Number of users.',
        value:2000,
        symbol:'+'
    },
    {
        title:'Governorate covered by services.',
        value:7,
        symbol:'+'
    },
    {
        title:'Benefited area',
        value:400,
        symbol:'+'
    },
]
export const teamData = [
    {
        image:client1,
        name:'James N. Green',
        property:'117 Properties',
        call:'1234567859',
        review:'42 Reviews'
    },
    {
        image:client2,
        name:'Seema Gauranki',
        property:'46 Properties',
        call:'1234567859',
        review:'33 Reviews'
    },
    {
        image:client3,
        name:'Adam Walcorn',
        property:'38 Properties',
        call:'1234567859',
        review:'16 Reviews'
    },
    {
        image:client4,
        name:'Jasmin Khatri',
        property:'51 Properties',
        call:'1234567859',
        review:'28 Reviews'
    },
    {
        image:client5,
        name:'Rudra K. Mathan',
        property:'75 Properties',
        call:'1234567859',
        review:'52 Reviews'
    },
    {
        image:client6,
        name:'Niharika Muthurk',
        property:'15 Properties',
        call:'1234567859',
        review:'46 Reviews'
    },
    {
        image:client7,
        name:'Grack Chappel',
        property:'17 Properties',
        call:'1234567859',
        review:'102 Reviews'
    },
    {
        image:client8,
        name:'Nikita Rajaswi',
        property:'62 Properties',
        call:'1234567859',
        review:'18 Reviews'
    },
]

export const blogData = [
    {
        id:1,
        image:p17,
        date:'13th Sept 2025',
        title:'Why people choose listio for own properties',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:2,
        image:p18,
        date:'29th Nov 2025',
        title:'List of benifits and impressive Resido services',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:3,
        image:p19,
        date:'29th Dec 2025',
        title:'What people says about listio properties',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:4,
        image:p20,
        date:'13th March 2025',
        title:'Why people choose listio for own properties',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:5,
        image:p21,
        date:'5th May 2025',
        title:'List of benifits and impressive Resido services',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id:6,
        image:p22,
        date:'19th June 2025',
        title:'What people says about listio properties',
        desc:'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
]

export const explorePlace = [
    {
        image:ct1,
        loction:'Chikago',
        property:'43 Properties'
    },
    {
        image:ct2,
        loction:'San Diego',
        property:'35 Properties'
    },
    {
        image:ct3,
        loction:'San Francisco',
        property:'42 Properties'
    },
    {
        image:ct4,
        loction:'Jacksonville',
        property:'47 Properties'
    },
    {
        image:ct5,
        loction:'Virginia Beach',
        property:'17 Properties'
    },
    {
        image:ct6,
        loction:'Philadelphia',
        property:'37 Properties'
    },
    {
        image:ct7,
        loction:'Seattle',
        property:'32 Properties'
    },
    {
        image:ct8,
        loction:'Houston',
        property:'26 Properties'
    },
    {
        image:ct9,
        loction:'Los Angeles',
        property:'18 Properties'
    },
    {
        image:ct10,
        loction:'Denver',
        property:'12 Properties'
    },
    {
        image:ct11,
        loction:'Oklahoma City',
        property:'22 Properties'
    },
    {
        image:ct12,
        loction:'Phoenix',
        property:'15 Properties'
    },
    {
        image:ct13,
        loction:'New York',
        property:'13 Properties'
    },
]

export const propertyType = [
    {
        icon:'fa-solid fa-house-laptop',
        name:'Commercial',
        property:'12 Properties'
    },
    {
        icon:'fa-solid fa-building',
        name:'Apartment',
        property:'16 Properties'
    },
    {
        icon:'fa-solid fa-building-shield',
        name:'Townhouse',
        property:'22 Properties'
    },
    {
        icon:'fa-solid fa-synagogue',
        name:'Villa',
        property:'18 Properties'
    },
    {
        icon:'fa-solid fa-mosque',
        name:'Offices',
        property:'42 Properties'
    },
    {
        icon:'fa-solid fa-tree-city',
        name:'Warehouses',
        property:'63 Properties'
    },
    {
        icon:'fa-solid fa-house',
        name:'Private House',
        property:'12 Properties'
    },
    {
        icon:'fa-solid fa-landmark-dome',
        name:'Openhouse',
        property:'16 Properties'
    },
    {
        icon:'fa-solid fa-city',
        name:'Building',
        property:'19 Properties'
    },
    {
        icon:'fa-solid fa-warehouse',
        name:'Shops',
        property:'17 Properties'
    },
    {
        icon:'fa-solid fa-shop-lock',
        name:'Studio',
        property:'10 Properties'
    },
    {
        icon:'fa-solid fa-building-columns',
        name:'Condos',
        property:'31 Properties'
    },
]

export const partnerLight = [
    pl1,pl2,pl3,pl4,pl5,pl6,pl7,pl8,pl9
]
export const partner = [
    pr1,pr2,pr3,pr4,pr5,pr6,pr7,pr8,pr9
]

export const categoriesData = [
    {
        icon:'fa-solid fa-house',
        title:'Private House',
        subTitle:'12 Properties',
        bg:'bg-light-success text-success'
    },
    {
        icon:'fa-solid fa-house',
        title:'Apartment',
        subTitle:'16 Properties',
        bg:'bg-light-warning text-warning'
    },
    {
        icon:'fa-solid fa-building-shield',
        title:'Townhouse',
        subTitle:'22 Properties',
        bg:'bg-light-danger text-danger'
    },
    {
        icon:'fa-solid fa-synagogue',
        title:'Villa',
        subTitle:'18 Properties',
        bg:'bg-light-info text-primary'
    },
    {
        icon:'fa-solid fa-mosque',
        title:'Offices',
        subTitle:'42 Properties',
        bg:'bg-light-success text-success'
    },
    {
        icon:'fa-solid fa-tree-city',
        title:'Warehouses',
        subTitle:'63 Properties',
        bg:'bg-light-danger text-danger'
    },
]

export const agentData = [
    {
        id:1,
        image:client1,
        name:'James N. Green',
        property:'117 Properties',
        call:'1234567859',
        review:'42 Reviews'
    },
    {
        id:2,
        image:client2,
        name:'Seema Gauranki',
        property:'46 Properties',
        call:'1234567859',
        review:'33 Reviews'
    },
    {
        id:3,
        image:client3,
        name:'Adam Walcorn',
        property:'38 Properties',
        call:'1234567859',
        review:'16 Reviews'
    },
    {
        id:4,
        image:client4,
        name:'Jasmin Khatri',
        property:'51 Properties',
        call:'1234567859',
        review:'28 Reviews'
    },
    {
        id:5,
        image:client4,
        name:'Rudra K. Mathan',
        property:'75 Properties',
        call:'1234567859',
        review:'52 Reviews'
    },
    {
        id:6,
        image:client6,
        name:'Niharika Muthurk',
        property:'15 Properties',
        call:'1234567859',
        review:'46 Reviews'
    },
    {
        id:7,
        image:client7,
        name:'Grack Chappel',
        property:'17 Properties',
        call:'1234567859',
        review:'102 Reviews'
    },
    {
        id:8,
        image:client8,
        name:'Nikita Rajaswi',
        property:'62 Properties',
        call:'1234567859',
        review:'42 Reviews'
    },
    {
        id:9,
        image:client1,
        name:'Rudra K. Mathan',
        property:'75 Properties',
        call:'1234567859',
        review:'52 Reviews'
    },
    {
        id:10,
        image:client2,
        name:'Niharika Muthurk',
        property:'15 Properties',
        call:'1234567859',
        review:'46 Reviews'
    },
    {
        id:11,
        image:client3,
        name:'Grack Chappel',
        property:'17 Properties',
        call:'1234567859',
        review:'102 Reviews'
    },
    {
        id:12,
        image:client4,
        name:'Nikita Rajaswi',
        property:'62 Properties',
        call:'1234567859',
        review:'18 Reviews'
    },
]

export const propertyInfo = [
    {
        title:'Ceo',
        subTitle:'Mr. Adam Vilawo'
    },
    {
        title:'Email',
        subTitle:'Isvali@gmail.com'
    },
    {
        title:'Phone',
        subTitle:'+91 235 658 4758'
    },
    {
        title:'Skype',
        subTitle:'isva24lia'
    },
    {
        title:'Address',
        subTitle:'320, Near Iswar'
    },
    {
        title:'City',
        subTitle:'New York'
    },
    {
        title:'Country',
        subTitle:'United State'
    },
    {
        title:'Stab',
        subTitle:'2007'
    },
]

export const featureProperty = [
    {
        image:p1,
        name:'Loss vengel New Apartment',
        loction:'Sans Fransico',
        type:'For Sale',
        bg:'property_types_vlix sale',
        value:'$4,240'
    },
    {
        image:p2,
        name:'Montreal Quriqe Apartment',
        loction:'Liverpool, London',
        type:'For Rent',
        bg:'property_types_vlix',
        value:'$7,380'
    },
    {
        image:p3,
        name:'Curmic Studio For Office',
        loction:'Montreal, Canada',
        type:'For Buy',
        bg:'property_types_vlix buy',
        value:'$8,730'
    },
    {
        image:p4,
        name:'Montreal Quebec City',
        loction:'Sreek View, New York',
        type:'For Rent',
        bg:'property_types_vlix',
        value:'$6,240'
    },
]

export const agencyData = [
    {
        id:1,
        image:ag1,
        agent:'5 Agents',
        name:'Green villa',
        property:'117 Properties'
    },
    {
        id:2,
        image:ag2,
        agent:'4 Agents',
        name:'Modern house',
        property:'76 Properties'
    },
    {
        id:3,
        image:ag3,
        agent:'3 Agents',
        name:'Royal Estate',
        property:'53 Properties'
    },
    {
        id:4,
        image:ag4,
        agent:'4 Agents',
        name:'Royal Green',
        property:'14 Properties'
    },
    {
        id:5,
        image:ag5,
        agent:'10 Agents',
        name:'Muskaan Estate',
        property:'63 Properties'
    },
    {
        id:6,
        image:ag6,
        agent:'9 Agents',
        name:'Red House',
        property:'18 Properties'
    },
    {
        id:7,
        image:ag7,
        agent:'8 Agents',
        name:'Green Villa',
        property:'69 Properties'
    },
    {
        id:8,
        image:ag8,
        agent:'7 Agents',
        name:'Estate City',
        property:'42 Properties'
    },
    {
        id:9,
        image:ag1,
        agent:'3 Agents',
        name:'House Design',
        property:'31 Properties'
    },
    {
        id:10,
        image:ag2,
        agent:'2 Agents',
        name:'Jumil Estate',
        property:'25 Properties'
    },
    {
        id:11,
        image:ag3,
        agent:'5 Agents',
        name:'House Stock',
        property:'18 Properties'
    },
    {
        id:12,
        image:ag4,
        agent:'6 Agents',
        name:'Ran Estate',
        property:'63 Properties'
    },
]

export const teamTwo = [
    {
        image:team1,
        name:'Shaurya Preet',
        position:'CEO'
    },
    {
        image:team2,
        name:'Shivangi Preet',
        position:'Co-Founder'
    },
    {
        image:team3,
        name:'Shaurya Preet',
        position:'MD'
    },
    {
        image:team4,
        name:'Shaurya Preet',
        position:'Manager'
    },
    {
        image:team5,
        name:'Shaurya Preet',
        position:'Manager'
    },
    {
        image:team6,
        name:'Shaurya Preet',
        position:'Manager'
    },
]
export const aboutDataTr = [
  {
    icon: 'fa-solid fa-unlock-keyhole text-primary',
    title: 'Vizyonumuz',
    desc: 'Toplumla ustaları buluşturan lider platform olmak ve profesyonel hizmetler pazarında teknolojiye ve güvene dayalı bir dönüşüm sağlamak.'
  },
  {
    icon: 'fa-brands fa-twitter text-primary',
    title: 'Hedeflerimiz',
    desc: 'Müşterilerin güvenilir ve profesyonel ustalara kolayca ulaşmasını sağlamak, ustaların hizmetlerini sergilemelerine ve yeni müşterilere ulaşma fırsatlarını artırmalarına destek olmak. Ayrıca değerlendirme ve incelemeler aracılığıyla güvenilir bir hizmet sağlayıcı ağı oluşturmak.'
  },
  {
    icon: 'fa-solid fa-layer-group text-primary',
    title: 'Misyonumuz',
    desc: 'Her ustanın ve zanaatkârın en iyiye ulaşmayı, gelişmeyi ve daha geniş bir müşteri kitlesine erişmeyi hak ettiğine inanıyoruz. Misyonumuz, ustalar ile müşterileri dijital bir ortamda kaliteli, hızlı ve rahat bir şekilde buluşturan bir köprü kurmaktır.'
  },
];

export const aboutData = [
    {
        icon:'fa-solid fa-unlock-keyhole text-primary',
        title:'رؤيتنا',
        desc:'أن نكون المنصة الأولى الرائدة في مجال ربط أصحاب المهن بالمجتمع، وتحقيق نقلة نوعية في سوق الخدمات المهنية من خلال الاعتماد على التكنولوجيا وبناء الثقة.'
    },
    {
        icon:'fa-brands fa-twitter text-primary',
        title:'أهدافنا',
        desc:'نهدف إلى تسهيل وصول العملاء إلى المهنيين المحترفين الموثوقين بكفاءة عالية، وتمكين أصحاب المهن من عرض خدماتهم وزيادة فرص وصولهم إلى عملاء جدد، إلى جانب بناء شبكة موثوقة من مقدمي الخدمات عبر التقييمات والمراجعات.'
    },
    {
        icon:'fa-solid fa-layer-group text-primary',
        title:'رسالتنا',
        desc:'نؤمن بأن صاحب كل مهنة أو حرفي يستحق أن يحصل على الأفضل ويتطور ويصل إلى قاعدة واسعة من العملاء، وتكمن رسالتنا في بناء جسر بين املهنة وطالبها ضمن بيئة رقمية تتيح الوصول والعرض بجودة وسرعة وراحة.'
    },
]
export const aboutDataEn = [
    {
        icon:'fa-solid fa-unlock-keyhole text-primary',
        title:'Our vision.',
        desc:'To be the leading platform in connecting professionals with the community and to achieve a qualitative leap in the professional services market through reliance on technology and building trust.'
    },
    {
        icon:'fa-brands fa-twitter text-primary',
        title:'Our goals',
        desc:'We aim to facilitate customers’ access to highly efficient and trusted professionals, enable service providers to showcase their services and increase their chances of reaching new clients, as well as build a reliable network of service providers through ratings and reviews.'
    },
    {
        icon:'fa-solid fa-layer-group text-primary',
        title:'Our mission',
        desc:'We believe that every professional or craftsman deserves to receive the best, develop, and reach a wide customer base. Our mission is to build a bridge between the profession and its seekers within a digital environment that enables access and presentation with quality, speed, and comfort.'
    },
]
export const blogCategories = [
    {
        title:'Lifestyle',
        subtitle:'09'
    },
    {
        title:'Travel',
        subtitle:'12'
    },
    {
        title:'Fashion',
        subtitle:'19'
    },
    {
        title:'Branding',
        subtitle:'17'
    },
    {
        title:'Music',
        subtitle:'10'
    },
]

export const recentPost = [
    {
        image:tour1,
        title:'Alonso Kelina Falao Asiano Pero',
        time:'10 Min ago'
    },
    {
        image:tour2,
        title:'It is a long established fact that a reader',
        time:'2 Hours ago'
    },
    {
        image:tour3,
        title:'Many desktop publish packages and web',
        time:'4 Hours ago'
    },
    {
        image:tour4,
        title:'Various versions have evolved over the years',
        time:'7 Hours ago'
    },
    {
        image:tour5,
        title:'Photo booth anim 8-bit PBR 3 wolf moon.',
        time:'3 Days ago'
    },
]

export const faqData = [
    {
        id:1,
        title:'How To Install Rikada Theme?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id:2,
        title:'What is main Requirements For Rikada?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id:3,
        title:'Why Choose Rikada Theme?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
]
export const faq2 = [
    {
        id:1,
        title:'May I Request For Refund?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id:2,
        title:'May I Get Any Offer in Future?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id:3,
        title:' How Much Time It will Take For refund?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
]
export const faq3 = [
    {
        id:1,
        title:'How To Upgrade Rikada Theme?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id:2,
        title:'Rikada available for WordPress Version?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id:3,
        title:'Why We need to upgrade Rikada?',
        desc:`Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
]

export const bookingDetail = [
    {
        title:'Booking ID/Num.',
        subTitle:'#BK1254872'
    },
    {
        title:'First Name',
        subTitle:'Shaurya'
    },
    {
        title:'Last Name',
        subTitle:'Preet'
    },
    {
        title:'Email',
        subTitle:'themezhub@gmail.com'
    },
    {
        title:'Phone',
        subTitle:'91 235 458 7458'
    },
    {
        title:'City',
        subTitle:'California'
    },
    {
        title:'Contry',
        subTitle:'United State'
    },
    {
        title:'Location',
        subTitle:'New Besil, Liverpool'
    },
    {
        title:'Zip',
        subTitle:'215467'
    },
]
export const myProperty = [
    {
        image:p1,
        name:'My List property Name',
        price:'from $ 154 month',
        listed:'Rentals and Apartments',
        city:'KASIA',
        area:'540 sq ft'
    },
    {
        image:p2,
        name:'My List property Name',
        price:'from $ 154 month',
        listed:'Rentals and Apartments',
        city:'KASIA',
        area:'540 sq ft'
    },
    {
        image:p3,
        name:'My List property Name',
        price:'from $ 154 month',
        listed:'Rentals and Apartments',
        city:'KASIA',
        area:'540 sq ft'
    },
    {
        image:p4,
        name:'My List property Name',
        price:'from $ 154 month',
        listed:'Rentals and Apartments',
        city:'KASIA',
        area:'540 sq ft'
    },
    {
        image:p5,
        name:'My List property Name',
        price:'from $ 154 month',
        listed:'Rentals and Apartments',
        city:'KASIA',
        area:'540 sq ft'
    },
]

export const bookmark = [
    {
        image:p1,
        name:'Serene Uptown',
        location:'6 Bishop Ave. Perkasie, PA',
        value:'$900 / monthly'
    },
    {
        image:p2,
        name:'Oak Tree Villas',
        location:'71 Lower River Dr. Bronx, NY',
        value:'$535,000'
    },
    {
        image:p3,
        name:'Selway Villas',
        location:'33 William St. Northbrook, IL',
        value:'$420,000'
    },
    {
        image:p4,
        name:'Town Manchester',
        location:'7843 Durham Avenue, MD',
        value:'$420,000'
    },
]






















